import { Button, Layout, PageHeader, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import HeaderComponent from '../HeaderComponent';
import ReactTable from 'react-table';
import { getAllVaccineData } from '../../services/api/cashless-vaccination';
import AddSponsors from './addSponsors';
import SidebarComponent from '../sidebarComponent';
const { Content } = Layout;

const VaccinationSponsors = () => {
  const [vaccines, setVaccinesData] = useState([]);
  const [pages, setPages] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [sponsor, setSponsorPage] = useState(false);
  const [vaccineId, setVaccineId] = useState(null);
  const [vaccineName, setVaccineName] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const tableColumns = [
    // {
    //   accessor: 'sponsorTableId',
    //   sortable: false,
    //   filterable: false,
    //   Header: 'Service Id',
    //   style: {
    //     textAlign: 'center',
    //   },
    // },
    {
      accessor: 'id',
      sortable: false,
      filterable: false,
      Header: 'Vaccination id',
      style: {
        textAlign: 'center',
      },
    },
    {
      accessor: 'vaccineName',
      filterable: false,
      Header: 'Vaccine Name',
      style: {
        textAlign: 'center',
      },
    },
    {
      accessor: 'vaccineCategoryName',
      filterable: false,
      Header: 'Category Name',
      style: {
        textAlign: 'center',
      },
    },
    {
      accessor: 'sponsorCount',
      filterable: false,
      Header: 'Sponsor Counts',
      style: {
        textAlign: 'center',
      },
    },
    {
      accessor: 'edit',
      filterable: false,
      Header: 'Edit',
      style: {
        textAlign: 'center',
      },
      Cell: (row) => {
        return (
          <Button
            onClick={() =>
              handleEdit(row.original.id, row.original.vaccineName)
            }
          >
            Edit Sponsor
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = (state) => {
    console.log({ state }, '[state][fetchData]');
    setLoading(true);
    const currPage = state && state.page ? state.page : currentPage;
    const currentPageSize = state && state.pageSize ? state.pageSize : pageSize;

    setCurrentPage(currPage);
    setPageSize(currentPageSize);
    const valid = (value) => typeof value === 'number';
    const params = {
      page: valid(currPage) ? currPage : currentPage,
      draw: valid(currentPageSize) ? currentPageSize : pageSize,
    };

    getAllVaccineData(params)
      .then((resp) => {
        console.log({ resp }, '[resp]');
        if (resp.body.message === 'success') {
          const totalCount = resp.body.count;
          const totalPages = Math.ceil(totalCount / currentPageSize);
          setVaccinesData(resp.body.data);
          setPages(totalPages);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  };

  const handleEdit = (vaccinationSubCategoryId, vaccineName) => {
    console.log(`Editing vaccination with ID ${vaccinationSubCategoryId}`);
    setVaccineId(vaccinationSubCategoryId);
    setVaccineName(vaccineName);
    setSponsorPage(true);
  };

  return (
    <Layout>
      <div>
        <HeaderComponent />
        <div style={{
          display: 'flex',
        }}>
          <div style={{ zIndex: 1000 }}>

            <SidebarComponent isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}/>
          </div>
          <div style={{width:'100%'}}>

      <Content>
        <PageHeader className="site-page-header" title="Vaccination Sponsors">
          <ReactTable
            data={vaccines}
            columns={tableColumns}
            loading={loading}
            className="-striped -highlight"
            textAlign="center"
            minRows={1}
            pages={pages}
            manual
            showPaginationTop
            showPaginationBottom
            onFetchData={(state) => fetchData(state)}
            pageSizeOptions={[10, 20, 50, 100]}
            getTrProps={(state, rowInfo) => ({
              style: {
                background: rowInfo
                  ? rowInfo.index % 2 === 0
                    ? '#DDF3F0'
                    : '#FFFFFF'
                  : null,
              },
            })}
          ></ReactTable>
        </PageHeader>
        {sponsor && (
          <AddSponsors
            sponsor={sponsor}
            vaccineId={vaccineId}
            vaccineName={vaccineName}
            onCancel={() => {
              setSponsorPage(false);
            }}
            refreshTableData={fetchData}
          />
        )}
      </Content>
      </div>
      </div>
      </div>
    </Layout>
  );
};

export default withRouter(VaccinationSponsors);
